import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function joinWaitlist(payload) {
  const { data } = await axios.post(`${API}/waitlist`, payload);
  return data;
}

export async function registerUser(payload) {
  const { data } = await axios.post(`${API}/register`, payload);
  return data;
}

// --- Ride-hailing app (Phase 1) ---
// Session lives in httpOnly cookies; silently refresh the short-lived access cookie on 401.
export const http = axios.create({ withCredentials: true });
let refreshing = null;
http.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  const url = cfg?.url || "";
  if (error.response?.status !== 401 || cfg._retried || /\/auth\/(login|register|refresh)$/.test(url)) {
    throw error;
  }
  cfg._retried = true;
  refreshing = refreshing || http.post(`${API}/auth/refresh`).finally(() => { refreshing = null; });
  await refreshing;
  return http(cfg);
});
const auth = () => ({});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => { const f = e?.loc?.[e.loc.length - 1]; const m = (e?.msg || "").replace(/^Value error, /, ""); return f && f !== "body" ? `${String(f).replace(/_/g, " ")}: ${m}` : m; }).join(" ");
  return detail.msg || String(detail);
}

export async function getGeo() {
  const { data } = await http.get(`${API}/geo/cities`);
  return data;
}
export async function estimateFare(payload) {
  const { data } = await http.post(`${API}/fare/estimate`, payload);
  return data;
}
export async function createRide(payload) {
  const { data } = await http.post(`${API}/rides`, payload, { headers: auth() });
  return data;
}
export async function getMyRides() {
  const { data } = await http.get(`${API}/rides/mine`, { headers: auth() });
  return data;
}
export async function getOpenRides(city) {
  const { data } = await http.get(`${API}/rides/open${city ? `?city=${encodeURIComponent(city)}` : ""}`, { headers: auth() });
  return data;
}
export async function getRide(id) {
  const { data } = await http.get(`${API}/rides/${id}`, { headers: auth() });
  return data;
}
export async function placeBid(id, amount) {
  const { data } = await http.post(`${API}/rides/${id}/bid`, { amount }, { headers: auth() });
  return data;
}
export async function acceptBid(rideId, bidId) {
  const { data } = await http.post(`${API}/rides/${rideId}/accept-bid/${bidId}`, {}, { headers: auth() });
  return data;
}
export async function advanceState(id, state) {
  const { data } = await http.post(`${API}/rides/${id}/state`, { state }, { headers: auth() });
  return data;
}
